import { Link } from 'react-router-dom';

export function PrivacyPage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Privacy Policy
                    </h2>
                    <p className="fs-8">
                      How Yapamar collects, uses, and protects personal data,
                      and the rights you have over it.
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>1. Controller</h5>
                    <p>
                      <strong>Name:</strong> Yapamar OÜ
                      <br />
                      <strong>Registry code:</strong> 17623834
                      <br />
                      <strong>Address:</strong> Sepapaja 6, Tallinn 15551,
                      Estonia
                      <br />
                      <strong>Email:</strong>{' '}
                      <a href="mailto:support@yapamar.com">
                        support@yapamar.com
                      </a>
                    </p>

                    <h5>2. Legal Basis and Purposes of Processing</h5>
                    <p>
                      The processing of personal data is based on the following
                      purposes and legal bases:
                    </p>
                    <ol>
                      <li>
                        <strong>
                          Service Provision and User Authentication
                        </strong>
                        <br />
                        <strong>Purpose:</strong> We process personal data to
                        create and manage user accounts, authenticate users,
                        provide access to our marketing intelligence platform,
                        and deliver contracted services.
                        <br />
                        <strong>Legal Basis:</strong> Article 6(1)(b) GDPR –
                        Processing is necessary for contract performance.
                      </li>
                      <li>
                        <strong>Security and Access Control</strong>
                        <br />
                        <strong>Purpose:</strong> We process personal data to
                        maintain platform security, prevent unauthorized access,
                        monitor system usage, and ensure service integrity.
                        <br />
                        <strong>Legal Basis:</strong> Article 6(1)(f) GDPR –
                        Processing is necessary for our legitimate interests in
                        maintaining platform security and operational integrity.
                      </li>
                      <li>
                        <strong>
                          Customer Support and Service Communications
                        </strong>
                        <br />
                        <strong>Purpose:</strong> We process personal data to
                        provide technical support, service notifications,
                        account management, and customer relationship
                        management.
                        <br />
                        <strong>Legal Basis:</strong> Article 6(1)(b) GDPR –
                        Processing is necessary for contract performance, and
                        Article 6(1)(f) GDPR – Processing is necessary for our
                        legitimate interests in providing effective customer
                        service.
                      </li>
                      <li>
                        <strong>
                          Website Analytics, Cookies, User Experience
                        </strong>
                        <br />
                        <strong>Purpose:</strong> We process personal data for
                        analysing website usage and optimizing platform
                        performance. This includes acquisition-source data
                        captured on entry to the site — referring URL, referring
                        domain, campaign parameters (e.g. utm_source,
                        utm_medium, utm_campaign, utm_term, utm_content) and
                        click identifiers (e.g. gclid, fbclid) — used to
                        understand how visitors reach the service. We use
                        cookies and similar tracking technologies to ensure
                        website functionality, analyse usage patterns, and
                        improve user experience. Our cookie policy is attached
                        to this Privacy Notice as Annex 1.{' '}
                        <Link to="/cookie-policy">Cookie Policy</Link>
                        <br />
                        <strong>Legal Basis:</strong> Article 6(1)(a) GDPR
                        (consent) for statistics cookies and website analytics,
                        Article 6(1)(b) GDPR for contract performance, and
                        Article 6(1)(f) GDPR based on our legitimate interests
                        in ensuring website functionality and security.
                      </li>
                      <li>
                        <strong>
                          Data Processing Services (Corporate Customers as data
                          controller and Yapamar as data processor)
                        </strong>
                        <br />
                        <strong>Purpose:</strong> We process personal data and
                        aggregated, anonymized business data provided by
                        Corporate Customers solely to provide the contracted
                        marketing intelligence services as instructed by such
                        Corporate Customers.
                        <br />
                        <strong>Legal Basis:</strong> Processing is conducted on
                        behalf of the Corporate Customer acting as data
                        controller. The legal basis is determined by the
                        Corporate Customer in accordance with their own privacy
                        policy and data protection obligations.
                      </li>
                    </ol>

                    <h5>3. Automated Decisions</h5>
                    <p>
                      Automated decision-making takes place when an electronic
                      system uses personal information to make a decision
                      without human intervention. You will not be subject to
                      decisions that have a significant impact on you based
                      solely on automated decision-making unless we have a
                      lawful basis for doing so and we have notified you. We do
                      not intend to make decisions about data subjects through
                      automated decision-making.
                    </p>
                    <p>
                      If we make an automated decision on the basis of any
                      particularly sensitive personal information, we must have
                      either your explicit written consent or it must be
                      justified in the public interest, and we must also put in
                      place appropriate measures to safeguard your rights.
                    </p>

                    <h5>4. Personal Data Collected</h5>
                    <p>
                      Personal data collection is necessary to provide our
                      contracted services, maintain platform security, ensure
                      proper user authentication, fulfill our legal obligations,
                      and provide effective customer support. Without providing
                      the required personal data, we cannot create your account,
                      deliver our services, process subscriptions, or provide
                      technical support and service communications. Optional
                      data collection will be clearly indicated, and you may
                      choose not to provide such information without affecting
                      core service functionality. We do not use personal data
                      for modelling purposes.
                    </p>
                    <p>
                      The following information of the data subjects may be
                      stored and processed:
                    </p>
                    <ul>
                      <li>
                        Personal identification information: name, email, phone
                        number, job title, IP address, usage logs.
                      </li>
                      <li>
                        In addition, the following data may be collected:
                        <ul>
                          <li>
                            Information related to the processing of the data,
                            such as the date of collection and the source of the
                            data.
                          </li>
                          <li>
                            Necessary information related to the use of
                            identification and authentication tools and
                            services.
                          </li>
                          <li>
                            Other information related to the purpose of the
                            processing, such as information that can be
                            connected to the data subject about the use of the
                            website when using the service, such as the user’s
                            IP address, time of visit, pages visited, browser
                            type used, network address from which the user came
                            to the website and the server from which the user
                            came to the website.
                          </li>
                        </ul>
                      </li>
                    </ul>

                    <p>
                      <strong>Advertising and KPI Platform Integrations</strong>
                    </p>
                    <p>
                      When you connect your advertising and KPI accounts (such
                      as Google Ads) to the Yapamar platform, you authorize
                      Yapamar to access your advertising and KPI data via the
                      official APIs of these platforms using OAuth 2.0
                      authentication.
                    </p>
                    <p>
                      For Google Ads specifically, we receive{' '}
                      <strong>read-only</strong>&nbsp;access to your Google Ads
                      accounts, campaigns, ad groups, ads, and performance data
                      (including impressions, clicks, cost, conversions, and
                      other metrics). This data is used&nbsp;
                      <strong>exclusively</strong> to build Marketing Mix Models
                      (MMM), calculate incremental impact, response curves, and
                      provide budget optimization recommendations within the
                      Yapamar platform.
                    </p>
                    <p>
                      We do <strong>not</strong> create, edit, pause, or manage
                      your campaigns or ads. You can disconnect the integration
                      at any time directly in your Yapamar account settings or
                      by revoking access in your Google Ads account.
                    </p>
                    <p>
                      All data received from advertising and KPI platforms is
                      processed as instructed by you (the data controller) and
                      is used only in aggregated and anonymized form for
                      modeling purposes. Yapamar acts as a data processor with
                      respect to this advertising and KPI data.
                    </p>

                    <h5>5. Retention Period of Personal Data</h5>
                    <p>
                      <strong>Account and Authentication Data:</strong> Retained
                      for the duration of the service agreement plus three
                      months after termination for account closure and
                      transition purposes.
                    </p>
                    <p>
                      <strong>Usage Logs and Technical Data:</strong> Retained
                      for the duration of the service agreement plus three
                      months for security monitoring and service improvement
                      purposes.
                    </p>
                    <p>
                      <strong>Customer Support Communications:</strong> Retained
                      for three years for service quality and dispute resolution
                      purposes.
                    </p>
                    <p>
                      <strong>Website Analytics and Cookie Data:</strong>{' '}
                      Retained for the period set out in Annex 1.
                    </p>
                    <p>
                      <strong>Data Processing Services:</strong> When Yapamar is
                      acting as data processor, personal data will be deleted or
                      returned to the Corporate Customer within 90 days of
                      effective date of service termination, unless applicable
                      law requires longer retention.
                    </p>
                    <p>
                      <strong>Legal Retention Requirements:</strong> Where legal
                      obligations require longer retention periods, data will be
                      retained only for the minimum period required by
                      applicable law.
                    </p>

                    <h5>6. How Data Is Collected</h5>
                    <p>
                      Data is primarily obtained from the following sources:
                      directly from the data subject and/or information
                      generated through the use of the service, cookies or
                      website by the data subject.
                    </p>
                    <p>
                      Data may also be obtained indirectly from the following
                      sources: data subject’s employer, who is Yapamar Corporate
                      Customer.
                    </p>

                    <h5>7. Disclosure or Transfer of Data</h5>
                    <p>
                      Processing tasks may be outsourced to external service
                      providers in accordance with and within the limits set by
                      data protection legislation. Main operators to whom
                      processing tasks have been outsourced or personal data
                      disclosed include:
                    </p>
                    <ul>
                      <li>
                        Technical Service Providers (cloud hosting, IT
                        infrastructure, software maintenance) – for service
                        delivery, platform functionality, and technical support.
                      </li>
                      <li>
                        Customer Support and Communication Providers (help desk
                        software, communication platforms) – for customer
                        service and technical assistance.
                      </li>
                      <li>
                        Analytics and Security Service Providers (website
                        analytics, cybersecurity firms, monitoring services) –
                        for platform performance optimization, security incident
                        response, and fraud prevention.
                      </li>
                      <li>
                        Authorized Customer Personnel – for service delivery as
                        instructed by the Corporate Customer acting as data
                        controller.
                      </li>
                      <li>
                        Government Authorities and Regulatory Bodies – when
                        required by law, legal process, or regulatory
                        compliance.
                      </li>
                    </ul>
                    <p>
                      The data shall not be disclosed to other parties than the
                      ones above, except in accordance with separate consent
                      and/or regulations.
                    </p>

                    <h5>8. Transfer of Data Outside the EU/EEA</h5>
                    <p>
                      Personal data may be transferred outside the European
                      Union or the European Economic Area in accordance with and
                      within the limits set by data protection regulation.
                    </p>
                    <p>
                      Personal data may be transferred to countries outside the
                      EU/EEA only when adequate safeguards are in place, such as
                      European Commission adequacy decisions, Standard
                      Contractual Clauses (SCCs) approved by the European
                      Commission, or other legally recognized transfer
                      mechanisms. You may request copies of these safeguards by
                      contacting us at{' '}
                      <a href="mailto:support@yapamar.com">
                        support@yapamar.com
                      </a>
                      .
                    </p>

                    <h5>9. Security Measures</h5>
                    <p>
                      We implement reasonable security measures to protect data
                      from unauthorized access, loss, or misuse, including
                      secure servers and encryption, limited access to personal
                      data, and regular security updates.
                    </p>

                    <h5>10. Rights of Data Subject</h5>
                    <p>
                      <strong>Right to access:</strong> Data subjects have the
                      right to receive confirmation on whether or not the
                      controller is processing personal data that concerns them.
                      The controller must provide the data subject with a copy
                      of the personal data being processed. As a rule, the
                      exercise of rights is free of charge.
                    </p>
                    <p>
                      <strong>Right to rectification:</strong> Data subjects
                      have the right to demand the rectification of inaccurate
                      personal data concerning them and to have incomplete
                      personal data completed.
                    </p>
                    <p>
                      <strong>Right to erasure:</strong> In certain cases,
                      specified in Article 17 of the GDPR, the data subject has
                      the right to have the controller erase data concerning
                      them. For example, when the personal data is no longer
                      necessary in relation to the purposes for which it was
                      collected or otherwise processed.
                    </p>
                    <p>
                      <strong>Right to restriction of processing:</strong> In
                      certain cases, specified in Article 18 of the GDPR, the
                      data subject can request the controller to restrict the
                      processing of personal data concerning them. The right to
                      restriction exists for example, when the data subject
                      contests the accuracy of the personal data. In such cases,
                      the processing will be restricted for a period enabling
                      the controller to verify the accuracy of the personal
                      data.
                    </p>
                    <p>
                      <strong>Right to object:</strong> In certain situations,
                      the data subject has the right to object to the processing
                      of their personal data. If the data is processed for the
                      performance of a task carried out for the purposes of the
                      compelling legitimate interests pursued by the controller
                      or a third party, the data subject has the right to object
                      to the processing on grounds relating to their particular
                      situation. In such cases, the processing must be stopped
                      unless the controller demonstrates compelling legitimate
                      grounds for the processing which override the interests,
                      rights and freedoms of the data subject.
                    </p>
                    <p>
                      <strong>Right to data portability:</strong> The data
                      subject has the right to receive the personal data that
                      they have provided to a controller in a structured,
                      commonly used and machine-readable format and, if desired,
                      transmit that data to another controller.
                    </p>
                    <p>
                      <strong>Right to withdraw consent:</strong> If personal
                      data is processed based on consent, the data subject has
                      the right to withdraw consent by informing the controller.
                      Consent to cookies can be withdrawn at any time via the
                      &quot;Cookie Settings&quot; link in the website footer.
                      Withdrawal of consent does not affect the lawfulness of
                      the processing carried out prior to the withdrawal of
                      consent.
                    </p>
                    <p>
                      <strong>
                        Right to lodge a complaint with the supervisory
                        authority:
                      </strong>{' '}
                      The data subject has the right to lodge a complaint with
                      the supervisory authority if the data subject considers
                      that the processing of personal data infringes the data
                      protection regulation.
                    </p>

                    <h5>
                      11. Contact Information and the Use of Data Subject Rights
                    </h5>
                    <p>
                      In all matters relating to the processing of personal data
                      and in situations involving the exercise of rights, the
                      data subject should contact the controller using the
                      contact details provided at the beginning of this privacy
                      notice.
                    </p>

                    <h5>12. Changes to Privacy Notice</h5>
                    <p>
                      We can make changes to this privacy notice if the methods
                      or purposes of the processing of personal data change.
                      However, the content of the privacy notice should be
                      reviewed on a regular basis.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
